import styled from 'styled-components';
import { COLOURS, Z_INDEX } from '@belong/themes';

/**
 * Ensure this component stretches to fill the available space. Without it,
 * the footer wil touch the header when there is nothing rendered in the <main>.
 */
export const ContentStretcher = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const NavHeader = styled.div`
  position: relative;
  z-index: ${Z_INDEX.GLOBAL_HEADER};
  background-color: ${COLOURS.BLACK};
  width: 100%;
`;
